module.exports = __webpack_public_path__ + "static/media/logo.9ceba4ca.png";